/* Shared validation for the custom RFQ organization fields. */
(function () {
  'use strict';
  if (window.mvpRfqOrganizationLimitInstalled) return;
  window.mvpRfqOrganizationLimitInstalled = true;
  const maximum = 35;
  const selector = '[data-mvp-rfq-organization]';
  function validate(field) {
    const valid = field.value.length <= maximum;
    field.setCustomValidity(valid ? '' : 'Use 35 characters or fewer for this name.');
    return valid;
  }
  function changed(event) {
    if (event.target.matches && event.target.matches(selector)) validate(event.target);
  }
  window.addEventListener('input', changed, true);
  window.addEventListener('change', changed, true);
  window.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    // form.elements also includes fields outside the form, such as the kit drawer.
    const fields = Array.from(form.elements).filter(field => field.matches(selector));
    const invalid = fields.filter(field => !validate(field));
    if (!invalid.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    invalid[0].focus();
    invalid[0].reportValidity();
  }, true);
})();
